import React from 'react';

import { LoadingSpinner } from '@consumer-frontend/shared-ui';

import styles from './LoadingCard.module.scss';

export type LoadingCardPropsT = {
  // Overridable for callers whose full-page wait isn't specifically "processing" (e.g. resolving
  // where to send the customer next) — defaults to the copy this app uses for that submission-in-
  // flight state, since that's its most common use.
  heading?: string;
  message?: string;
};

export type LoadingCardT = React.FC<LoadingCardPropsT>;

export const LoadingCard: LoadingCardT = ({
  heading = 'Processing...',
  message = 'Please do not close, refresh, or navigate away from this page.',
}) => (
  <div className={styles.card}>
    <div className={styles.spinner}>
      <LoadingSpinner />
    </div>
    <h2 className={styles.heading}>{heading}</h2>
    <p className={styles.message}>{message}</p>
  </div>
);
